import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/deprecated/GridCard/GridCard';
import { LandscapeContent } from '@bnnvara/cards/src/components/deprecated/GridCard/LandscapeContent/LandscapeContent';
import { HalfImageHalfTextCardContainer } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardContainer';
import { HalfImageHalfTextCardImage } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardImage';
import { HalfImageHalfTextCardText } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardText';
import { OnHoverTextEffect } from '@bnnvara/cards/src/components/shared/OnHoverTextEffect';
import { Small } from '@bnnvara/cards/src/components/shared/Small';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import { formatDate } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';

import resizeImageSource from '../../../helpers/resizeImageSource';
import * as S from './styled';

export const VideoCard = ({ title, image, publishDate, layout }) => {
  const thumbnail = resizeImageSource(
    image ? image.url || image : '/static/fallbackImages/videofallback.jpg',
    450,
    1
  );
  const pubDate = formatDate(new Date(publishDate), 'dd-MM-yyyy');
  const theme = useTheme();

  if (layout === null) {
    return (
      <HalfImageHalfTextCardContainer>
        <HalfImageHalfTextCardImage
          image={{
            alt: title,
            isLazyLoaded: true,
            src: thumbnail,
          }}
        />
        <HalfImageHalfTextCardText>
          <OnHoverTextEffect>
            <Title>{title}</Title>
          </OnHoverTextEffect>
          <S.Details>
            <Small color={theme.secondary.light}>{pubDate}</Small>
          </S.Details>
        </HalfImageHalfTextCardText>
      </HalfImageHalfTextCardContainer>
    );
  }

  return (
    <GridCard layout={layout}>
      <LandscapeContent
        title={title}
        pubDate={pubDate}
        backgroundImage={thumbnail}
      />
    </GridCard>
  );
};

VideoCard.defaultProps = {
  image: null,
  layout: null,
};

VideoCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  publishDate: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
};

export default VideoCard;
